import { useEffect, useRef } from "react";

export const useSocketEvents = (socket, handlers = {}) => {
  const handlersRef = useRef(handlers);

  // Her render'da ref'i güncelle (böylece listener'ları söküp takmaya gerek kalmaz)
  useEffect(() => {
    handlersRef.current = handlers;
  });

  useEffect(() => {
    if (!socket || typeof socket.on !== 'function') return;

    // Wrapper fonksiyonlar (Ref üzerinden en güncel handler'a erişir)
    const onNewTaskWrapper = (...args) => handlersRef.current.onNewTask && handlersRef.current.onNewTask(...args);
    const onTaskUpdatedWrapper = (...args) => handlersRef.current.onTaskUpdated && handlersRef.current.onTaskUpdated(...args);
    const onOfferUpdatedWrapper = (...args) => handlersRef.current.onOfferUpdated && handlersRef.current.onOfferUpdated(...args);
    const onNewOfferWrapper = (...args) => handlersRef.current.onNewOffer && handlersRef.current.onNewOffer(...args);
    const onDeleteTaskWrapper = (...args) => handlersRef.current.onDeleteTask && handlersRef.current.onDeleteTask(...args);
    const onDeleteOfferWrapper = (...args) => handlersRef.current.onDeleteOffer && handlersRef.current.onDeleteOffer(...args);
    const onOfferAcceptedWrapper = (...args) => handlersRef.current.onOfferAccepted && handlersRef.current.onOfferAccepted(...args);
    const onOfferRejectedWrapper = (...args) => handlersRef.current.onOfferRejected && handlersRef.current.onOfferRejected(...args);
    const onAgreementCancelledWrapper = (...args) => handlersRef.current.onAgreementCancelled && handlersRef.current.onAgreementCancelled(...args);
    const onAgreementCancellationRequestedWrapper = (...args) => handlersRef.current.onAgreementCancellationRequested && handlersRef.current.onAgreementCancellationRequested(...args);
    const onNewReviewWrapper = (...args) => handlersRef.current.onNewReview && handlersRef.current.onNewReview(...args);

    // Chat event wrappers
    const onNewChatNotificationWrapper = (...args) => handlersRef.current.onNewChatNotification && handlersRef.current.onNewChatNotification(...args);

    // Listeners Ekle
    socket.on("newTaskForService", onNewTaskWrapper);
    socket.on("taskUpdated", onTaskUpdatedWrapper);
    socket.on("offerUpdated", onOfferUpdatedWrapper);
    socket.on("newOffer", onNewOfferWrapper);
    socket.on("taskDeleted", onDeleteTaskWrapper);
    socket.on("offerDeleted", onDeleteOfferWrapper);

    // Yeni eklenenler
    socket.on("offerAccepted", onOfferAcceptedWrapper);
    socket.on("offerRejected", onOfferRejectedWrapper);
    socket.on("agreementCancelled", onAgreementCancelledWrapper);
    socket.on("agreementCancellationRequested", onAgreementCancellationRequestedWrapper);
    socket.on("newReview", onNewReviewWrapper);

    // Chat bildirimi
    socket.on("newChatNotification", onNewChatNotificationWrapper);

    return () => {
      if (socket) {
        socket.off("newTaskForService", onNewTaskWrapper);
        socket.off("taskUpdated", onTaskUpdatedWrapper);
        socket.off("offerUpdated", onOfferUpdatedWrapper);
        socket.off("newOffer", onNewOfferWrapper);
        socket.off("taskDeleted", onDeleteTaskWrapper);
        socket.off("offerDeleted", onDeleteOfferWrapper);

        socket.off("offerAccepted", onOfferAcceptedWrapper);
        socket.off("offerRejected", onOfferRejectedWrapper);
        socket.off("agreementCancelled", onAgreementCancelledWrapper);
        socket.off("agreementCancellationRequested", onAgreementCancellationRequestedWrapper);
        socket.off("newReview", onNewReviewWrapper);

        socket.off("newChatNotification", onNewChatNotificationWrapper);
      }
    };
  }, [socket]); // Sadece socket değişirse çalışır (handlers değişirse ref güncellenir, effect çalışmaz)
};

